import LinkedInAccessToken from './LinkedInAccessToken';

export default LinkedInAccessToken;
